import React from "react";
import { motion } from "framer-motion"; // Importing framer-motion
import LoadingButton from "./LoadingButton";

interface ButtonProps {
  className?: string; // Optional className prop
  buttonName: string;
  loading?: boolean;
  buttonDisabled?: boolean;
  buttonType?: boolean;
  buttonOnclick?: () => void
  testId?: string;
  textSize?: string;
  textColor?: string;
  buttonHight?: string;
  bgColor?: string;
  buttonWidth?: string;
}

const Button: React.FC<ButtonProps> = ({ bgColor, buttonWidth, className, loading, buttonType, buttonName, buttonHight, buttonDisabled, buttonOnclick, testId, textSize, textColor }) => {
  // Motion variants for button animation
  const buttonVariants = {
    hidden: { opacity: 0, y: 0 }, // Starts slightly above and invisible
    visible: { opacity: 1, y: 0 },  // Fades in and slides to final position
    hover: { scale: 1 }, // Slightly enlarges the button on hover
    tap: { scale: 1 }, // Shrinks when the button is pressed
  };
  return (
    <motion.button
      className={`
        ${buttonHight || 'h-[60px] '}
        gap-[8px] 
        ${buttonWidth || 'max-w-[410px]'}
        rounded-lg
        ${bgColor || 'bg-p_primary'}
        text-center
        disabled:bg-disable_stroke
        disabled:text-disable_text
        disabled:cursor-not-allowed
        text-nowrap
        ${textColor || 'text-white'}
        ${textSize || "text-heading3"}
        ${className || ""}
      `}
      disabled={buttonDisabled || loading}
      type={buttonType ? "submit" : "button"}
      variants={buttonVariants}
      data-testid={testId}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      whileTap="tap"
      onClick={buttonOnclick}
      transition={{ duration: 0.4, ease: "easeInOut" }} // Smooth transition for hover and tap
    >
      {loading ? <LoadingButton /> : buttonName}
    </motion.button>
  );
};

export default Button;
